<script lang="ts">
  import { onMount } from "svelte"

  // Year for copyright notice
  const currentYear = new Date().getFullYear()

  

  let isVisible = false

  onMount(() => {
    isVisible = true
  })
</script>

<footer
  class="bg-gradient-to-b from-slate-900 to-slate-950 py-8 text-slate-400"
>
  <div
    class="container mx-auto px-6 transition-opacity duration-700"
    class:opacity-0={!isVisible}
    class:opacity-100={isVisible}
  >
    <!-- Simple footer with minimal content -->
    <div class="flex flex-col items-center justify-center">
      <!-- Social Links -->

      <!-- Copyright and Links -->
      <div class="text-center text-sm">
        <p>&copy; {currentYear} Hollas.net. All rights reserved.</p>
        <div class="mt-2 space-x-2">
          <a
            href="/privacy"
            class="text-slate-400 hover:text-blue-400 transition-colors"
            >Privacy Policy</a
          >
          <span class="text-slate-700">|</span>
          <a
            href="/cookie-policy"
            class="text-slate-400 hover:text-blue-400 transition-colors"
            >Cookie Policy</a
          >
          <span class="text-slate-700">|</span>
          <a
            href="/terms"
            class="text-slate-400 hover:text-blue-400 transition-colors"
            >Terms of Service</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>

<style>
  .opacity-0 {
    opacity: 0;
  }

  .opacity-100 {
    opacity: 1;
  }
</style>
